import { queryPromise } from '../../api';
import * as d3 from 'd3';
import * as moment from 'moment';

const createPiechartIcon = function (colorArr) {
  const piechartSize = 25;
  const strokeWidth = 1.5;
  const radius = Math.min(piechartSize, piechartSize) / 2;

  const newSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  newSVG.setAttributeNS(null, 'version', '1.1');
  newSVG.setAttributeNS(null, 'height', piechartSize);
  newSVG.setAttributeNS(null, 'width', piechartSize);
  const svg = d3
    .select(newSVG)
    .attr('width', piechartSize)
    .attr('height', piechartSize);

  const g = svg.append('g').attr('transform', 'translate(' + piechartSize / 2 + ',' + piechartSize / 2 + ')');

  const data = colorArr.map(c => 1);
  const color = d3.scaleOrdinal(colorArr);
  const pie = d3.pie();

  const arc = d3
    .arc()
    .innerRadius(0)
    .outerRadius(radius - strokeWidth);

  //Generate groups
  const arcs = g
    .selectAll('arc')
    .data(pie(data))
    .enter()
    .append('g')
    .attr('class', 'ksm-map__arc');

  //Draw arc paths
  arcs
    .append('path')
    .attr('fill', function (d, i) {
      return color(i);
    })
    .attr('d', arc)
    .style('stroke', 'white')
    .style('stroke-width', strokeWidth);

  const svgStr = new XMLSerializer().serializeToString(newSVG);
  const svgIcon = new Image();
  svgIcon.src = 'data:image/svg+xml;base64,' + btoa(svgStr);
  return svgIcon;
};

const fensterDataObject = {
  stadtindex: null,
  zIndex: 0,
  visible: false,
  overlay: null,
  lineLayer: null,
  lineFeature: null,
  infoItems: null, //ortsFenster
  infoItem: null, //infoFenster
  type: null,
  x: 0,
  y: 0
};

const state = {
  fetched: false,
  data: {
    activeInfoItem: null,
    lastActiveInfoItem: null,
    geoData: null,
    merzgebieteGeoData: null,
    fensterDataCollection: [],
    sidebarLeftList: [
      {
        label: 'Infotext',
        color: '',
        show: true,
        isInfoText: true,
        isExpand: true
      }
    ],
    sidebarRightList: [
      {
        label: 'Holland-Dada-Feldzug 1923',
        id: 'holland',
        color: '#b80718',
        typ: '224',
        indexID: [16],
        checked: true,
        textDocId: '582',
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: true,
        showTitle: false
      },
      {
        label: 'Merzabende',
        id: 'merzabende',
        typ: '225',
        indexID: [16],
        color: '#f39400',
        checked: true,
        textDocId: 1173,
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: false,
        showTitle: false
      },
      {
        label: 'Merzgebiete',
        id: 'merzgebiete',
        typ: null,
        indexID: [],
        color: 'rgb(245, 235, 118)',
        checked: true,
        textDocId: null,
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: false,
        merzgebiete: [],
        showTitle: false
      },
      {
        label: 'Veranstaltungsorte',
        id: 'veranstaltung',
        color: '#009ee3',
        indexID: [16],
        typ: null,
        checked: true,
        textDocId: null,
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: false,
        showTitle: true
      },
      {
        label: 'Ausstellungsorte',
        id: 'ausstellung',
        color: '#009037',
        indexID: [15],
        typ: null,
        checked: true,
        textDocId: null,
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: false,
        showTitle: true
      },
      {
        label: 'Veröffentlichungsorte',
        id: 'veröffentlichung',
        color: '#004594',
        indexID: [10, 11],
        typ: null,
        checked: true,
        textDocId: null,
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: false,
        showTitle: true
      },
      {
        label: 'Institutionen',
        id: 'institutionen',
        color: '#94127d',
        indexID: [12],
        typ: null,
        checked: true,
        textDocId: null,
        textDoc: null,
        show: true,
        infoItems: [],
        stadtIndexList: [],
        isExpand: false,
        showTitle: true
      }
    ]
  }
};

const getters = {
  filterMerzgebieteGeoData: state => {
    const accor = state.data.sidebarRightList.find(accor => accor.id === 'merzgebiete');
    accor.merzgebiete.forEach(mgb => {
      const b = mgb.checked && accor.checked ? true : false;
      mgb.list.forEach(it => {
        it.show = b;
      });
    });
    return state.data.merzgebieteGeoData;
  },
  fensterDataCollection: state => {
    return state.data.fensterDataCollection;
  },
  sidebarRightList: state => {
    return state.data.sidebarRightList;
  },
  sidebarLeftList: state => {
    return state.data.sidebarLeftList;
  },
  activeInfoItem: state => {
    return state.data.activeInfoItem;
  },
  fensterDataByFeature: state => ({ feature, type }) => {
    const stadtindex = feature.get('stadtindex');
    return state.data.fensterDataCollection.find(d => d.stadtindex === stadtindex && d.type === type);
  }
};

const actions = {
  prepareAllfensterDataCollection(store) {
    const geoData = state.data.geoData;
    if (!geoData) {
      return store.state.data.fensterDataCollection;
    }
    store.state.data.fensterDataCollection = [];
    ['infoFenster', 'ortsFenster'].forEach(type => {
      geoData.features
        .filter(f => f.properties.icon)
        .forEach(f => {
          const fensterData = JSON.parse(JSON.stringify(fensterDataObject));
          fensterData.type = type;
          fensterData.stadtindex = f.properties.stadtindex;
          fensterData.stadtname = f.properties.stadtname;
          store.commit('addFensterData', fensterData);
        });
    });
    return store.getters.fensterDataCollection;
  },

  navigatorInfoFenster(store, { infoItem, to }) {
    const infoItems = infoItem.accor.infoItems;
    let idx = infoItems.indexOf(infoItem);
    idx = idx + to;
    if (idx < 0 || idx > infoItems.length - 1) {
      return;
    }

    store.state.data.lastActiveInfoItem = infoItem;
    store.commit('activeInfoItem', infoItems[idx]);
  },

  updateAllOrtsFensterData(store) {
    state.data.fensterDataCollection.forEach(fensterData => {
      store.commit('updateOrtsFensterInfoItems', fensterData);
    });
  },

  fetchGeoData: async function (store, vue) {
    if (state.data.geoData) {
      return state.data.geoData;
    }
    //query api

    const resJson = await queryPromise('getOrteUndWege?expandInfo=true');
    const geoData = resJson.info.cities;
    const rows = resJson.info.performances;
    const sidebarRightList = state.data.sidebarRightList;
    const merzgebieteGeoData = resJson.info.merzgebiete;
    const merzgebietIdx = resJson.info.merzgebietIdx;

    geoData.features.forEach(f => {
      f.properties.stadtindex = f.properties.stadtindex.toString();
    });

    //init rows
    rows.forEach(row => {
      row.short_113_html = '';
      row.full_113_html = '';
      if (row.doc) {
        const doc = row.webdoc ? row.webdoc : row.doc;
        const doc_113_html = row.webdoc ? doc['114_html'] : doc['113_html'];
        if (doc_113_html) {
          const tmp = document.createElement('div');
          tmp.innerHTML = doc_113_html;
          const arr = tmp.textContent.split(' ');
          const words = [];
          for (let i = 0; i < 3; i++) {
            if (arr[i]) {
              words.push(arr[i]);
            }
          }
          row.short_113_html = '(' + words.join(' ') + '...)';
          row.full_113_html = vue.$_getNewHtmlElement(
            doc_113_html,
            null,
            { _source: doc },
            true
          ).innerHTML;
        }
      }
      if (row.stadtindex) {
        row.stadtindex = row.stadtindex.toString();
      }
      //datum formatieren
      let datvon = row.datvon;
      let _datvon = '';
      let _datbis = '';
      row._datvon = '';
      if (datvon) {
        let arrRes = [];
        datvon.split('-').forEach(a => {
          if (parseInt(a, 10) !== 0) {
            arrRes.push(a);
          }
        });
        _datvon = arrRes.reverse().join('.');
        if (_datvon.split('.').length === 2) {
          _datvon = moment(_datvon, 'MM.YYYY').locale('de').format('MMMM YYYY');
        }
      } else {
        row.datvon = '';
      }

      //datum formatieren
      let datbis = row.datbis;
      row._datbis = '';
      if (datbis) {
        let arrRes = [];
        datbis.split('-').forEach(a => {
          if (parseInt(a, 10) !== 0) {
            arrRes.push(a);
          }
        });
        _datbis = arrRes.reverse().join('.');
        if (_datbis.split('.').length === 2) {
          _datbis = moment(_datbis, 'MM.YYYY').locale('de').format('MMMM YYYY');
        }
      } else {
        row.datbis = '';
      }

      if (_datvon && _datbis && _datvon === _datbis) {
        _datbis = '';
      }
      row._datvon = _datvon;
      row._datbis = _datbis;

    });

    //sort rows by datvon    
    rows.sort((a, b) => {
      const d = a.datvon.replace(/-/g, '') - b.datvon.replace(/-/g, '');
      if (d > 0) {
        return 1;
      } else if (d < 0) {
        return -1;
      }
      return 0;
    });

    rows.forEach(row => {
      //add row to feature of geoData
      let _stadtindex = row.stadtindex || row.ortsindex;
      const _stadtindexList = _stadtindex.toString().split('#');
      row._stadtindexList = _stadtindexList;

      //add row to accordion / set sidebarRightList/ row assortment
      let indexID = row.indexID;

      if (indexID !== 16) {
        //Ausstellungsorte /Institueionen / Veröfftlichungsorte       
        const _accor = sidebarRightList.find(accor => accor.indexID.indexOf(indexID) >= 0);
        _accor.infoItems.push({ accor: _accor, row: row });
      } else if (row.typ) {
        //Dada-Feldzug /Merzabende
        sidebarRightList
          .filter(accor => row.typ.indexOf(accor.typ) >= 0)
          .forEach(accor => {
            accor.infoItems.push({ accor: accor, row: row });
          });

        //Veranstaltungsorte
        const veranstaltung = row.typ.split('#').find(t => t !== '224' && t !== '225');
        if (veranstaltung) {
          const _accor = sidebarRightList.find(accor => accor.label === 'Veranstaltungsorte');
          _accor.infoItems.push({ accor: _accor, row: row });
        }
      }
    });

    const textIds = [];
    //set accor stadtIndexList
    sidebarRightList.forEach(accor => {
      if (accor.textDocId) {
        textIds.push(accor.textDocId);
      }
      const stadtIndexObj = {};
      accor.infoItems.forEach(item => {
        item.row._stadtindexList.forEach(i => {
          stadtIndexObj[i] = true;
        });
      });
      accor.stadtIndexList = Object.keys(stadtIndexObj);

      if (accor.id === 'veröffentlichung') {
        accor.infoItems.sort((a, b) => {
          const aName = a.row.stadtName ? a.row.stadtName : a.row.ortsname;
          const bName = b.row.stadtName ? b.row.stadtName : b.row.ortsname;

          if (aName && bName) {
            return aName.localeCompare(bName, 'de');
          }
        })
      }
    });

    const docsJson = await queryPromise('document/' + textIds.join(','));
    docsJson.doc.forEach(doc => {
      const id = doc._id;
      sidebarRightList.find(accor => accor.textDocId - id === 0).textDoc = doc;
    });

    //set merzgebiete
    const merzAccor = sidebarRightList.find(accor => accor.id === 'merzgebiete');
    const merzgebietFeatures = merzgebieteGeoData.features;
    const colors = d3.scaleOrdinal(d3.schemeCategory10);
    merzgebietIdx.forEach((idxRow, i) => {
      const list = merzgebietFeatures.filter(feature => {
        const mgb = feature.properties.merzgebiet;
        if (mgb && mgb.split('#').indexOf(idxRow.ID.toString()) > -1) {
          feature.properties.color = colors(i);
          return true;
        }
      });
      merzAccor.merzgebiete.push({
        name: 'Merzgebiet ' + idxRow.data,
        checked: false,
        list: list,
        color: colors(i)
      });
    });

    state.data.geoData = geoData;
    state.data.merzgebieteGeoData = merzgebieteGeoData;
    store.commit('updatePiechartIcon');
    return state.data.geoData;
  }
};

const mutations = {
  ['addFensterData'](state, fensterData) {
    state.data.fensterDataCollection.push(fensterData);
  },

  ['updateOrtsFensterInfoItems'](state, fensterData) {
    const stadtindex = fensterData.stadtindex;
    const tmpList = [];
    state.data.sidebarRightList
      .filter(accor => accor.checked)
      .forEach(accor => {
        accor.infoItems
          .filter(item => item.row._stadtindexList.indexOf(stadtindex) > -1)
          .forEach(item => {
            tmpList.push(item);
          });
      });
    fensterData.infoItems = tmpList;
  },

  ['updatePiechartIcon'](state) {
    const checkedAccor = state.data.sidebarRightList.filter(it => it.checked);
    state.data.geoData.features.forEach(feature => {
      const stadtindex = feature.properties.stadtindex;
      const colors = checkedAccor
        .filter(accor => {
          return accor.stadtIndexList.indexOf(stadtindex) > -1;
        })
        .map(accor => {
          return accor.color;
        });

      if (colors.length > 0) {
        feature.properties.icon = createPiechartIcon(colors);
        feature.properties.iconSize = [25, 25];
      } else {
        delete feature.properties.icon;
        delete feature.properties.iconSize;
      }
    });
  },
  ['activeInfoItem'](state, data) {
    state.data.activeInfoItem = data;
  },
  ['expandAccor'](state, data) {
    state.data.sidebarRightList.forEach(accor => {
      if (accor === data) {
        accor.isExpand = true;
      } else {
        accor.isExpand = false;
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/orteundwege.js